import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Button, Row } from 'reactstrap';
import { Field, } from 'redux-form';
import renderFileInputField from '../../../../../../shared/components/form/FileInput';
import TextField from '@material-ui/core/TextField';
import moment from 'moment';
import history from '../../../../../../history';
import PrintIcon from '@material-ui/icons/Print';
import pdfMake from 'pdfmake/build/pdfmake.js';
import PrintsProceduresPDF from '../PrintsProceduresPDF';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SelectorTemplate from '../SelectorTemplate';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import Tooltip from '@material-ui/core/Tooltip';
import Spinner from 'react-bootstrap/Spinner';

const renderField = ({
  input, placeholder, type, meta: { touched, error },
}) => (
  <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
    <input {...input} placeholder={placeholder} type={type} />
    {touched && error && <span className="form__form-group-error">{error}</span>}
  </div>
);

renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderField.defaultProps = {
  placeholder: '',
  meta: null,
  type: 'text',
};

class EKG extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      dataMedications: [],
      specialists: [],
      specialty: '',
      professionals: [],
      addedDiagnostics: [],
      openModal: false,
      loadProfessionals: false,
      professional: "",
      ritmo: "",
      fc: "",
      ondaP: "",
      pr: "",
      qr_s: "",
      eje_qrs: "",
      styt: "",
      qtc: "",
      conclusions: "",
      diagnostico: "",
      descripcion_d: "",
      urlLogo: 'https://i.postimg.cc/WpG6Rg5q/logo-SAC-App-New.png',
      dataPatient: [],
      age: '',
      date: new Date(),
      birthday: null,
      today: new Date(),
      day: new Date(),
      profile: sessionStorage.getItem('perfil'),
      ekgFiles: []
    }
  }

  componentDidMount() {
    this.getDataIndividually();
    //this.getData();
    this.setState({ addedDiagnostics: this.props.addedMedicaments })
  }

  checkForFilesByThisProcedure = () => {
    let ekgFiles = this.props.filesProcedures.filter((file) => file.procedure === 'EKG');
    this.setState({ ekgFiles })
  }

  /*  componentDidUpdate(prevProps) {
     if (JSON.stringify(prevProps.filesProcedures) !== JSON.stringify(this.props.filesProcedures))
       this.checkForFilesByThisProcedure()
   } */

  getDataIndividually = () => {

    this.setState({ loadProfessionals: true }, async () => {
      let specialistList = await this.fetchDataSpecialist();
      let professionales = await this.fetchDataProfessionals();
      console.log("specialistList", specialistList, "professionales", professionales);
      if (!!specialistList && this.props.id_professionalFromEvent !== null) {
        let id_specialty = "";
        professionales.map((professional) => {
          if (professional.id_profesional === this.props.id_professionalFromEvent) {
            id_specialty = professional.id_especialidad
          }
        });
        this.setState({ specialty: id_specialty }, () => {
          this.setState({ professional: this.props.professional, loadProfessionals: false });
          this.props.handlerMedicalProcedures("EKG", "professional", this.props.professional);
        });
      }
    })
  }

  getData = () => {
    this.setState({ loadProfessionals: true }, () => {
      Promise.all([this.fetchDataSpecialist(), this.fetchDataProfessionals()]).then((result) => {
        this.setState({ specialists: result[0], professionals: result[1] }, () => {
          if (this.props.id_professionalFromEvent !== null) {
            var id_specialty = "";
            result[1].map((professional) => {
              if (professional.id_profesional === this.props.id_professionalFromEvent) {
                id_specialty = professional.id_especialidad
              }
            });
            this.setState({ specialty: id_specialty, professional: this.props.professional, loadProfessionals: false }, () => {
              //this.props.handlerMedicalProcedures("EKG", "professional", this.props.professional);
            });
          }
        });
      })
        .catch(error => console.log(`Error in promises ${error}`));
    })
  }

  fetchDataSpecialist = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'especialidad/listar', {
        method: 'GET',
        headers: {
          authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }
      })
        .then(response => {
          return response.json();
        })
        .then(specialists => {
          resolve(specialists);
        })
        .catch((error) => {
          reject(error)
        });
    });
  };

  fetchDataProfessionals = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'profesional/listar', {
        method: 'GET',
        headers: {
          authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }
      })
        .then(response => {
          return response.json();
        })
        .then(professionals => {
          resolve(professionals);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  saveProcedure() {

    const day = new Date();
    const data = {
      id_historia: this.props.data.id_historia,
      id_admision: this.props.data.id_admision,
      fecha: moment(day).format("YYYY-MM-DD"),
      hora: moment(day).format('LT'),
      eco: {
        profesional: "",
        vid: "",
        pp: "",
        ps: "",
        vis: "",
        fe: "",
        rao: "",
        anillo_oa: "",
        vd: "",
        ai: "",
        a: "",
        e: "",
        tap_se: "",
        ad: "",
        resposo: "",
        ejercicio: "",
        conclusions: "",
        diagnostico: "",
        descripcion_d: ""
      },
      stress: {
        profesional: "",
        vid: "",
        pp: "",
        ps: "",
        vis: "",
        fe: "",
        rao: "",
        ao: "",
        anillo_oa: "",
        vd: "",
        ai: "",
        a: "",
        e: "",
        tap_se: "",
        adult: "",
        description: "",
        conclusions: "",
        diagnostico: "",
        descripcion_d: "",
      },
      prueba: {
        professional: "",
        conclusiones: "",
        conclusions: "",
        diagnostico: "",
        descripcion_d: ""
      },
      ekg: {
        professional: this.props.professional.nombres + " " + this.props.professional.apellido1,
        ritmo: this.state.ritmo,
        fc: this.state.fc,
        ondaP: this.state.ondaP,
        pr: this.state.pr,
        qr_s: this.state.qr_s,
        eje_qrs: this.state.eje_qrs,
        styt: this.state.styt,
        qtc: this.state.qtc,
        conclusions: this.state.conclusions,
        diagnostico: this.state.addedDiagnostics,
        descripcion_d: ""
      },
      holter: {
        professional: "",
        conclusion: "",
        medicament: "",
        descripcion_d: ""
      },
      map: {
        professional: "",
        conclusion: "",
        diagnostico: "",
        descripcion_d: ""
      },
    }

    console.log(data);

    fetch(process.env.REACT_APP_PUBLIC_URL + 'procedimientos/create', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        console.log(data);
        alert("procedimiento creado correctamente");
        history.push({
          pathname: process.env.PUBLIC_URL + '/pages/search-clinic-history',
        });
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  loadDataPatient = () => {
    var data = { num_documento: this.props.num_documento };

    fetch(process.env.REACT_APP_PUBLIC_URL + 'paciente/consultar', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (data.existe) {
          console.log(data.contenido[0]);
          this.setState({ dataPatient: data.contenido[0] });
          this.calculateAge(data.contenido[0].fec_nacimiento);
        }

      }).catch((error) => {
        console.error('Error:', error);
      });
  }

  calculateAge = (birthday) => {
    let fecha = moment(birthday, "YYYYMMDD").fromNow(true);
    let nacimiento = moment(birthday).format("YYYY-MM-DD");
    let hoy = new Date();
    this.setState({ age: fecha, birthday: nacimiento, today: moment(hoy).format('LLL'), day: moment(hoy).format('LL') });
    this.PrintProcedurePDF();
  }

  PrintProcedurePDF = async () => {

    const fecha = this.state.today;
    const name = this.state.dataPatient.tip_documento + '-' + this.state.dataPatient.num_documento + ' ' + this.state.dataPatient.nombres + ' ' + this.state.dataPatient.apellido1 + ' ' + this.state.dataPatient.apellido2;

    const header = {
      image: await this.getBase64ImageFromURL(this.state.urlLogo),
      width: 80,
      height: 30,
      alignment: 'center',
      margin: [0, 10, 0, 20]
    }


    const documentDefinition = {
      pageSize: 'LETTER',
      pageOrientation: 'portrait',
      header: header,
      footer: function (currentPage, pageCount) {

        return {
          table: {
            widths: ['*', '*', '*'],
            body: [
              [{ text: "Pagina " + currentPage.toString() + ' de ' + pageCount, style: 'head' }, { text: name, style: 'head' }, { text:'Fecha Impresion: ' + fecha, style: 'head' }],
            ]
          },
          layout: 'noBorders',
          margin: [20, 0, 0, 5],
        };
      },
      content: [
        {
          text: 'ELECTROCARDIOGRAMA', style: 'title', margin: 15
        },
        {
          text: 'Lugar y fecha, Santiago de cali ' + fecha, style: 'textStyle'
        },
        {
          // auto-sized columns have their widths based on their content                                       
          margin: [0, 5, 0, 10],
          table: {
            widths: ['*', '*', '*', '*'],
            body: [
              [{ text: 'Nombre del Paciente', bold: true, style: 'textStyle' }, { text: this.state.dataPatient.nombres + ' ' + this.state.dataPatient.apellido1 + ' ' + this.state.dataPatient.apellido2, style: 'textStyle' }, { text: 'Documento de Identificacions', bold: true, style: 'textStyle' }, { text: this.state.dataPatient.tip_documento + '-' + this.state.dataPatient.num_documento, style: 'textStyle' }],
              [{ text: 'Edad ', bold: true, style: 'textStyle' }, { text: this.state.age, style: 'textStyle' }, { text: 'Genero ', bold: true, style: 'textStyle' }, { text: this.state.dataPatient.sexo, style: 'textStyle' }],
              [{ text: 'Historia Clinilca ', bold: true, style: 'textStyle' }, { text: this.state.dataPatient.id_historia, style: 'textStyle' }, { text: 'Tipo de Usuario ', bold: true, style: 'textStyle' }, ''],
              [{ text: 'Diagnostico ', bold: true, style: 'textStyle' }, '', '', ''],
            ]
          },
        },
        {
          margin: [140, 10, 0, 10],
          table: {
            widths: [80, 160],
            headerRows: 1,
            body: [
              [{ text: 'Ritmo', bold: true, style: 'textStyle' }, { text: this.state.ritmo === "" ? "-" : this.state.ritmo, style: 'textStyle' }],
              [{ text: 'FC', bold: true, style: 'textStyle' }, { text: this.state.fc === "" ? "-" : this.state.fc, style: 'textStyle' }],
              [{ text: 'Onda P', bold: true, style: 'textStyle' }, { text: this.state.ondaP === "" ? "-" : this.state.ondaP, style: 'textStyle' }],
              [{ text: 'PR', bold: true, style: 'textStyle' }, { text: this.state.pr === "" ? "-" : this.state.pr, style: 'textStyle' }],
              [{ text: 'QRS', bold: true, style: 'textStyle' }, { text: this.state.qr_s === "" ? "-" : this.state.ondaP, style: 'textStyle' }],
              [{ text: 'EJE QRS', bold: true, style: 'textStyle' }, { text: this.state.eje_qrs === "" ? "-" : this.state.eje_qrs, style: 'textStyle' }],
              [{ text: 'EJE QRS', bold: true, style: 'textStyle' }, { text: this.state.eje_qrs === "" ? "-" : this.state.eje_qrs, style: 'textStyle' }],
              [{ text: 'ST y T', bold: true, style: 'textStyle' }, { text: this.state.styt === "" ? "-" : this.state.styt, style: 'textStyle' }],
              [{ text: 'QTC', bold: true, style: 'textStyle' }, { text: this.state.qtc === "" ? "-" : this.state.qtc, style: 'textStyle' }],
            ]
          },
        },
        {
          text: 'CONCLUSIÓN', style: 'title'
        },
        {
          text: this.state.conclusions === "" ? "" : this.state.conclusions, style: 'textStyle'
        },
        {
          text: '\n\n\n\n\n\n\n\n UNIDAD DE ESPECILISTAS MEDICAS S.A.S \n Calle 9C No. 50-25 Clinica farallones Telefonos: 5133729 - 5133783 \n', style: 'tableTexStyle'
        },
      ],
      styles: {
        head: {
          fontSize: 7,
          bold: true,
          alignment: 'left'
        },
        title: {
          fontSize: 10,
          bold: true,
          alignment: 'center',

        },
        textStyle: {
          fontSize: 9,
        },
        tableTexStyle: {
          fontSize: 8,
          alignment: 'center'
        },
        foter: {
          alignment: 'center',
          fontSize: 6,
        },
      }
    };

    pdfMake.createPdf(documentDefinition).open();

  }

  getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        var dataURL = canvas.toDataURL("image/png");

        resolve(dataURL);
      };

      img.onerror = error => {
        reject(error);
      };

      img.src = url;
    });
  }

  handlerSpeciality = (event) => {
    this.setState({ specialty: event.target.value });
  }

  handlerProfessional = (professional) => {
    this.setState({ professional: professional });
  }

  handlerRitmo = (ritmo) => {
    this.setState({ ritmo: ritmo });
  }

  handlerFc = (fc) => {
    this.setState({ fc: fc });
  }

  handlerOndaP = (ondaP) => {
    this.setState({ ondaP: ondaP });
  }

  handlerPr = (pr) => {
    this.setState({ pr: pr });
  }

  handlerQrs = (qrs) => {
    this.setState({ qrs: qrs });
  }

  handlerEjeQrs = (ejeQrs) => {
    this.setState({ ejeQrs: ejeQrs });
  }

  handlerStyt = (styt) => {
    this.setState({ styt: styt });
  }

  handlerQtc = (qtc) => {
    this.setState({ qtc: qtc });
  }

  handlerConclusion = (conclusion) => {
    this.setState({ conclusions: conclusion })
  }

  printPDF = async () => {
    await this.props.saveProceduresPatient().then((saved) => {
      if (saved) {
        PrintsProceduresPDF.printPDF(this.props.id_admision, "EKG");
      }
    }).catch((err) => {
      console.log(err);
    })
  }

  onChangeTemplate = (template) => {
    if (template != null && template != undefined) {
      this.props.handlerMedicalProcedures("EKG", "conclusions", template.contenido, "nameTemplete", template.plantilla);
      //this.props.handlerNameTemplete("EKG", "nameTemplete", template.plantilla);
      this.handlerConclusion(template.contenido);
    }
  }

  handlerTextfieldFileProcedure = (e) => {
    console.log("WHATISTHISndTime", e);
    this.props.handlerFileProcedure(e.target.files[0], this.props.dataProcedure.id_servicio);
    //this.inputFileTestRef.current.value = null
  }

  render() {

    return (<Col>
      <div className="form" style={{ flex: 1, flexDirection: 'column' }}>
        <div className="card__title">
          <h5 className="bold-text">EKG</h5>
        </div>


        <Row>
          <Col md={6}>
            <SelectorTemplate
              typeProcedure={2}
              onChangeTemplate={(template) => {
                this.onChangeTemplate(template);
              }}
              disabled={this.props.isCloseClinicHistory}
            />
          </Col>
        </Row>
        <br />

        <div style={{ flex: 1, flexDirection: 'row', marginBottom: 20 }}>
          <TextField
            required
            disabled
            id="specilaity-standard-required"
            label="Especialidad"
            type="text"
            value={typeof this.props.professional.especialidad === 'undefined' ? "" : this.props.professional.especialidad}
            onChange={(e) => {
              this.handlerSpeciality(e.target.value);
            }}
          />
          <TextField
            required
            disabled
            id="professional-standard-required"
            label="Profesional"
            type="text"
            value={`${this.props.professional.nombres} ${this.props.professional.apellido1}`}
            onChange={(e) => {
              this.handlerProfessional(e.target.value);
            }}
          />
        </div>

      </div>
      <div className="form">

        <div style={{ margin: 10 }}>
          <CKEditor
            style={{ width: '100%', height: '200px' }}
            editor={ClassicEditor}
            disabled={this.props.isCloseClinicHistory}
            data={this.props.dataProcedure.conclusions != null ? this.props.dataProcedure.conclusions : ''}
            onChange={(event, editor) => {
              const data = editor.getData();
              this.props.handlerMedicalProcedures("EKG", "conclusions", data);
              this.handlerConclusion(data);
            }}
          />
        </div>

      </div>

      <Button
        style={{ marginTop: 20 }}
        color="primary"
        disabled={this.props.isCloseClinicHistory}
        onClick={() => { this.printPDF() }}
      >
        Guardar e Imprimir
      </Button>

      {!!this.props.dataProcedure.ekgFiles &&
        this.props.uploadFileProcedure ?
        <Spinner style={{ width: '24px', height: '24px' }} animation="border" variant="success" />
        :
        !!this.props.dataProcedure.ekgFiles.length ?
          this.props.dataProcedure.ekgFiles.map(ekgFile => (
            <div style={{ margin: '0em 2em' }} key={ekgFile.id_procedimiento_adjunto}>
              <div>
                <b>{ekgFile.adjunto}</b>
              </div>
              <Tooltip title="Ver Documento">
                <Button
                  className="btn btn-sm"
                  color="primary"
                  onClick={() => {
                    window.open(ekgFile.wholeUrl, '_blank');
                  }}
                >
                  <FontAwesomeIcon icon={faFile} />
                </Button>
              </Tooltip>
              <Tooltip title="Eliminar Documento">
                <Button
                  className="btn btn-sm"
                  color="danger"
                  onClick={() => {
                    this.props.deleteFileProcedure(ekgFile.id_admision, ekgFile.id_servicio, ekgFile.procedure);
                  }}
                >
                  <FontAwesomeIcon icon={faTrashAlt} />
                </Button>
              </Tooltip>
            </div>
          ))
          : <div>
            <span className="form__form-group-label">
              Agregar adjunto
            </span>
            <div >
              <TextField
                id="file-procedure-ekg-standard-required"
                type="file"
                variant="outlined"
                className="material-form__field"
                //ref={this.inputFileEcoRef}
                inputProps={{
                  multiple: false
                }}
                onChange={(e) => {
                  this.handlerTextfieldFileProcedure(e);
                }}
              />
              {/* <Field
                name="file-medical-procedure"
                component={renderFileInputField}
                onChange={(e) => {
                  console.log("WHATISHERE", e)
                  this.props.handlerFileProcedure(e, this.props.dataProcedure.id_servicio)
                }}
              /> */}
            </div>
          </div>}

    </Col>)

  }
}

export default EKG;